module.exports = __webpack_public_path__ + "img/first_section_strawberries_small.3fef1ed2.jpg";